
    import { Component, Vue } from 'vue-property-decorator';
    import Layout from '@/components/layout/Layout.vue';
    import Table from '@/components/table/Table.vue';
    import {ApiRepository} from '@/api';
    import InputText from '@/components/form/Input-text.vue';
    import _ from 'lodash';
    import InputSelect from '@/components/form/Input-select.vue';
    import {formatDate} from '@/helpers/utils';
    import { __ } from "@/helpers/utils";

    @Component({
        components: {
            InputSelect,
            InputText,
            Layout,
            Table
        },
    })
    export default class ApplicationShow extends Vue {
        private application: any = [];
        private statuses = {
            'new': ['new', 'approved', 'denied'],
            'approved': ['approved', 'cancelled'],
            'cancelled': this.$store.getters.role === 'partner' ? ['cancelled'] : ['cancelled', 'anonymize'],
            'denied': ['denied']
        };
        private newStatus = '';
        private message = '';
        private disableButton = false;

        public async mounted() {
            this.application = await ApiRepository.getApplication(this.$route.params.application);
            this.newStatus = this.application.status;
        }

        private async changeStatus(event: any) {
            event.preventDefault();
            this.disableButton = true;
            var statusResponse = await ApiRepository.changeApplicationStatus(this.$route.params.application, this.newStatus, this.message);
            if (statusResponse) {
              this.disableButton = false;
              this.application = await ApiRepository.getApplication(this.$route.params.application);
            }
        }

        private keys = {
            note: 'Správa',
            status: 'Zmena stavu',
            user: 'Zmenil',
            date: 'Dátum zmeny'
        };

        private data = [];

        private orderedLogs() {
            let orderedLogs = _.orderBy(this.application.logs, 'createdAt', 'desc');

            orderedLogs = orderedLogs.map(log => {
                return {
                    note: log.message,
                    status: (log.oldStatus ? __(log.oldStatus) + ' => ' : '') + __(log.newStatus),
                    user: log.user ? log.user.email : '',
                    date: formatDate(log.createdAt)
                };
            });

            return orderedLogs;
        }

        private toDate(date: any, format: string = 'DD.MM.YYYY HH:mm:ss') {
            return formatDate(date, format);
        }

        private translate(term: string) {
            return __(term);
        }
    }
